import { render, staticRenderFns } from "./PoiSubSledge.vue?vue&type=template&id=437f4c10"
import script from "./PoiSubSledge.js?vue&type=script&lang=js&external"
export * from "./PoiSubSledge.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports